import { TypographyP } from "@/components/typography/P";
import Dialog from "@/components/ui/dialog";
import MDEditor from "@uiw/react-md-editor";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { ReactNode, useState } from "react";

type Props = {
  children: ReactNode;
  releaseNotes: string;
  isDarkMode: boolean;
};

const ReleaseNotesModal = ({ children, releaseNotes, isDarkMode }: Props) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <Dialog.Root
      open={openModal}
      onOpenChange={(open) => {
        setOpenModal(open);
      }}
    >
      <div className="min-w-max bg-brand-gray-50 dark:bg-brand-gray-800 border border-brand-gray-100 dark:border-brand-gray-600 rounded-md flex justify-between items-center gap-4 py-2.5 px-4 mt-4">
        <TypographyP>View the release notes for this app</TypographyP>
        <Dialog.Trigger asChild className="flex items-center gap-4">
          {children}
        </Dialog.Trigger>
      </div>
      <Dialog.Content
        className="max-h-[700px] max-w-3xl overflow-y-scroll dark:bg-[#0d1118]"
        data-color-mode={isDarkMode ? "dark" : "light"}
      >
        <span
          onClick={() => setOpenModal(false)}
          className="py-3 px-4 cursor-pointer absolute top-0 right-0"
          role="button"
          tabIndex={-1}
          aria-label="Close window"
        >
          <X
            size={16}
            fontWeight="bold"
            className="text-brand-gray-600 dark:text-brand-gray-200"
          />
        </span>
        <AnimatePresence mode="wait">
          <motion.div
            key="release-notes"
            className="relative overflow-hidden"
            initial={{ top: "8px", opacity: 0 }}
            animate={{ top: "0px", opacity: 1 }}
            exit={{ top: "8px", opacity: 0, height: "24px" }}
          >
            <MDEditor.Markdown className="p-[18px]" source={releaseNotes} />
          </motion.div>
        </AnimatePresence>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default ReleaseNotesModal;
